import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import StudentCheckinActions, { StudentCheckinRedux, StudentCheckinTypes } from '../Redux/StudentCheckinRedux'
import { notificationFail } from '../Redux/NotificationActions'

const studentCheckinCrudObservable = createCRUDObservable({
  mainRedux: StudentCheckinRedux,
  reduxPath: 'studentCheckin',
})

const studentCheckinExcelEpic = (action$, store, { Api }) =>
  action$.ofType(StudentCheckinTypes.StudentCheckinExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.studentCheckin.getStudentCheckinExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            StudentCheckinActions.StudentCheckinExcelSuccess(),
          ]
        })
    ))

export const studentCheckinObservers = Object.assign({}, studentCheckinCrudObservable.observers, {})

export const studentCheckinEpic = combineEpics(
  studentCheckinCrudObservable.epic,
  studentCheckinExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/StudentCheckinObservable.js